<template>
    <v-chip
            :color="getColor"
            :class="[
            setClasses,
            'elevation-0', 
            'filter-list-item', 
            'has-matches',
            anySelected ? 'column-selected' : 'column-not-selected',
            isActive ? 'white--text is-active' : 'black--text'
        ]">
        <v-avatar v-if="shouldDisplayAvatar"
                  class="item-avatar"
                  color="white"
                  size="32">
            <img :src="extractUserAvatarUrl({ user: item })">
        </v-avatar>
        <div class="list-item-content">
            <div class="item-label">{{ item.name }}</div>
            <div v-if="showPlus===false && viewLoaded===false" class="item-matches">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
            <div v-else class="item-matches">{{ filterCount }}</div>
        </div>

    </v-chip>
</template>


<script>
    import extractUserAvatarUrl from '@/helpers/extractUserAvatarUrl'
    import {mapState} from "vuex";

    export default {
        name: 'filter-list-item',

        props: {
            item: {
                type: Object,
                required: true
            },
            isActive: {
                type: Boolean,
                default: false
            },
            anySelected: {
                type: Boolean,
                default: false
            },
            parentId: {
                type: String,
                default: '',
                required: false
            },
            id: {
                type: String,
                default: '',
                required: false
            },
            type: {
                type: String,
                default: '',
                required: false
            },
            setClasses: {
                type: String,
                default: '',
                required: false
            },
        },

        watch: {
            filterCount: function (newCount, oldCount) {

            },
        },


        methods: {
            extractUserAvatarUrl,

            getFilterCount(t) {
                var ret
                if (this.type === "absences") {
                    ret = this.$store.getters.getAbsencesFilterCount(t)
                } else if (this.type === "users") {
                    ret = this.$store.getters.getUsersFilterCount(t)
                } else {
                    ret = this.$store.getters.getFilterCount(t)
                }
                return ret
            },
        },

        computed: {
            /*
            ...mapGetters({
                getFilterCount: 'getFilterCount'
            }),
            */
            ...mapState({
                viewLoaded: state => state.jobs.jobsLoaded,
            }),

            showPlus() {
                return (this.anySelected && this.isActive == false)
            },

            filterCount() {
                //return (this.isActive == false ) ? '' : this.getFilterCount(this)
                //if (this.anySelected && this.getFilterCount(this)==0 && this.isActive==false) {
                if (this.showPlus) {
                    return "+"
                } else {
                    return this.getFilterCount(this)
                }

            },

            getColor() {
                if (this.isActive) {
                    return 'blue darken-4'
                } else if (parseInt(this.filterCount) === 0) {
                    return 'blue lighten-4' //gray hide-number
                } else {
                    return 'blue force-hover lighten-4'
                }
            },

            // Since Filter List Item gets used in diff areas, come up with criteria
            // to show avater or not
            shouldDisplayAvatar() {
                if (this.item.avatar_urls) {
                    return true
                }
                return false
            }
        }

    }
</script>